var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 15.1105V18.2355H6.12402L15.3407 9.01881L12.2157 5.89382L2.99902 15.1105ZM17.7574 6.60215C18.0824 6.27715 18.0824 5.75215 17.7574 5.42715L15.8074 3.47715C15.4824 3.15215 14.9574 3.15215 14.6324 3.47715L13.1074 5.00215L16.2324 8.12715L17.7574 6.60215Z",
    fill: "#4B69F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/EditFilled.3a4ee194bfb32dfbc035759f789a1d7e.svg";
export { ForwardRef as ReactComponent };